import { createFiltersActions } from '../utils';

export const ACTIONS_PREFIX = 'MOBILE_DEVICES';

export const {
    updateFilters,
    applyFilters,
    resetApplyFilters,
    resetApplyFiltersSilently,
    rebuildApplyFilters,
    rebuildApplyFiltersSilently
} = createFiltersActions(ACTIONS_PREFIX);
